import { Navigate, Outlet, RouteObject } from "react-router";

import { MapEditorFeatureListRoute } from "../mapEditor/routes/MapEditorFeatureListRoute";
import ProtocolCreateRoute from "../settings/protocol/routes/ProtocolCreateRoute";
import ProtocolEditRoute from "../settings/protocol/routes/ProtocolEditRoute";
import ProtocolListRoute from "../settings/protocol/routes/ProtocolListRoute";
import RequiredProject from "./components/RequireProject";
import ProjectCostScreen from "./screens/ProjectCostScreen";
import { ProjectDeliverablesScreen } from "./screens/ProjectDeliverablesScreen";
import { ProjectExportCreateScreen } from "./screens/ProjectExportCreateScreen";
import { ProjectExportListScreen } from "./screens/ProjectExportListScreen";
import ProjectMapEditorScreen from "./screens/ProjectMapEditorScreen";
import { ProjectMapEditorLayerFeatureScreen } from "./screens/ProjectMapEditorScreen/ProjectMapEditorLayerFeatureScreen";
import { ProjectMapEditorLayerScreen } from "./screens/ProjectMapEditorScreen/ProjectMapEditorLayerScreen";
import { ProjectMapEditorLayerSettingsScreen } from "./screens/ProjectMapEditorScreen/ProjectMapEditorLayerScreen/ProjectMapEditorLayerSettingsScreen";
import { ProjectOverviewScreen } from "./screens/ProjectOverviewScreen";
import { ProjectReviewVisitV2Screen } from "./screens/ProjectReviewVisitV2Screen";
import ProjectReviewVisitV2FinalReportRoute from "./screens/ProjectReviewVisitV2Screen/routes/ProjectReviewVisitV2FinalReportRoute";
import { ProjectReviewVisitV2FunctionsRoute } from "./screens/ProjectReviewVisitV2Screen/routes/ProjectReviewVisitV2FunctionsRoute";
import { ProjectReviewVisitV2FunctionDetailRoute } from "./screens/ProjectReviewVisitV2Screen/routes/ProjectReviewVisitV2FunctionsRoute/routes/ProjectReviewVisitV2FunctionDetailRoute";
import { ProjectReviewVisitV2FunctionListRoute } from "./screens/ProjectReviewVisitV2Screen/routes/ProjectReviewVisitV2FunctionsRoute/routes/ProjectReviewVisitV2FunctionListRoute";
import { CreatedFunctionsTab } from "./screens/ProjectReviewVisitV2Screen/routes/ProjectReviewVisitV2FunctionsRoute/routes/ProjectReviewVisitV2FunctionListRoute/screens/ProjectReviewVisitV2FunctionsListRouteCreatedFunctionsTab";
import { PossibleFunctionsTab } from "./screens/ProjectReviewVisitV2Screen/routes/ProjectReviewVisitV2FunctionsRoute/routes/ProjectReviewVisitV2FunctionListRoute/screens/ProjectReviewVisitV2FunctionsListRoutePossibleFunctionsTab";
import { ProjectReviewVisitV2PossibleFunctionObservationDetailRoute } from "./screens/ProjectReviewVisitV2Screen/routes/ProjectReviewVisitV2FunctionsRoute/routes/ProjectReviewVisitV2PossibleFunctionObservationDetailRoute";
import { ProjectReviewVisitV2ObservationsRoute } from "./screens/ProjectReviewVisitV2Screen/routes/ProjectReviewVisitV2ObservationsRoute";
import { ProjectReviewVisitV2ObservationDetailRoute } from "./screens/ProjectReviewVisitV2Screen/routes/ProjectReviewVisitV2ObservationsRoute/routes/ProjectReviewVisitV2ObservationDetailRoute";
import { ProjectReviewVisitV2ObservationListRoute } from "./screens/ProjectReviewVisitV2Screen/routes/ProjectReviewVisitV2ObservationsRoute/routes/ProjectReviewVisitV2ObservationListRoute";
import { ProjectReviewVisitV2OverviewRoute } from "./screens/ProjectReviewVisitV2Screen/routes/ProjectReviewVisitV2OverviewRoute";
import { ProjectReviewVisitV2TeamReportsRoute } from "./screens/ProjectReviewVisitV2Screen/routes/ProjectReviewVisitV2TeamReportsRoute";
import { ProjectReviewVisitV2TimeReportsRoute } from "./screens/ProjectReviewVisitV2Screen/routes/ProjectReviewVisitV2TimeReportsRoute";
import { ProjectReviewVisitV2WeatherReportsRoute } from "./screens/ProjectReviewVisitV2Screen/routes/ProjectReviewVisitV2WeatherReportsRoute";
import ProjectUpdateScreen from "./screens/ProjectUpdateScreen";
import ProjectUserCreateScreen from "./screens/ProjectUserCreateScreen";
import ProjectUserListScreen from "./screens/ProjectUserListScreen";
import { ProjectVisitListScreen } from "./screens/ProjectVisitListScreen";

export const projectRoutes: RouteObject[] = [
    {
        path: "p/:projectSlug",
        element: (
            <RequiredProject>
                <Outlet />
            </RequiredProject>
        ),
        children: [
            {
                index: true,
                element: <ProjectOverviewScreen />,
            },
            {
                path: "map-editor",
                element: <ProjectMapEditorScreen />,
                children: [
                    {
                        path: ":layerId",
                        element: <ProjectMapEditorLayerScreen />,
                        children: [
                            {
                                index: true,
                                element: <MapEditorFeatureListRoute />,
                            },
                            {
                                path: "settings",
                                element: <ProjectMapEditorLayerSettingsScreen />,
                            },
                        ],
                    },
                    {
                        path: ":layerId/:mapEditorFeatureId",
                        element: <ProjectMapEditorLayerFeatureScreen />,
                    },
                ],
            },
            {
                path: "review-visit/:visitId/",
                element: <ProjectReviewVisitV2Screen />,
                children: [
                    {
                        index: true,
                        element: <ProjectReviewVisitV2OverviewRoute />,
                    },
                    {
                        path: "time-reports",
                        element: <ProjectReviewVisitV2TimeReportsRoute />,
                    },
                    {
                        path: "weather-reports",
                        element: <ProjectReviewVisitV2WeatherReportsRoute />,
                    },
                    {
                        path: "team-reports",
                        element: <ProjectReviewVisitV2TeamReportsRoute />,
                    },
                    {
                        path: "functions",
                        element: <ProjectReviewVisitV2FunctionsRoute />,
                        children: [
                            {
                                element: <ProjectReviewVisitV2FunctionListRoute />,
                                children: [
                                    {
                                        index: true,
                                        element: <Navigate to="possible" />,
                                    },
                                    {
                                        path: "possible",
                                        element: <PossibleFunctionsTab />,
                                    },
                                    {
                                        path: "created",
                                        element: <CreatedFunctionsTab />,
                                    },
                                ],
                            },
                            {
                                path: "possible/:mapEditorFeatureId",
                                element: <ProjectReviewVisitV2PossibleFunctionObservationDetailRoute backHref="../" />,
                            },
                            {
                                path: "possible/:mapEditorFeatureId/created/:mapEditorFeatureId",
                                element: <ProjectReviewVisitV2FunctionDetailRoute backHref="../../" />,
                            },
                            {
                                path: "created/:mapEditorFeatureId",
                                element: <ProjectReviewVisitV2FunctionDetailRoute backHref="../" />,
                            },
                            {
                                path: "created/:mapEditorFeatureId/observations/:mapEditorFeatureId",
                                element: <ProjectReviewVisitV2PossibleFunctionObservationDetailRoute backHref="../../" />,
                            },
                        ],
                    },
                    {
                        path: "observations",
                        element: <ProjectReviewVisitV2ObservationsRoute />,
                        children: [
                            {
                                index: true,
                                element: <ProjectReviewVisitV2ObservationListRoute />,
                            },
                            {
                                path: ":mapEditorFeatureId",
                                element: <ProjectReviewVisitV2ObservationDetailRoute />,
                            },
                        ],
                    },
                ],
            },
            {
                path: "review-visit/:visitId/finalReport",
                element: <ProjectReviewVisitV2FinalReportRoute />,
            },
            {
                path: "visits",
                children: [
                    {
                        // todo: breadcrumbs JOSHUA HELP
                        path: ":visitId",
                        element: <ProjectReviewVisitV2FinalReportRoute />,
                    },
                ],
            },
            {
                handle: { breadcrumb: "project:projectMenu.settings" },
                path: "settings",
                element: <ProjectUpdateScreen />,
            },
            { handle: { breadcrumb: "project:projectMenu.cost" }, path: "cost", element: <ProjectCostScreen /> },
            {
                handle: { breadcrumb: "project:projectMenu.planning" },
                path: "planned",
                element: <ProjectVisitListScreen />,
            },
            {
                path: "export",
                handle: { breadcrumb: "project:projectMenu.projectExport" },
                children: [
                    {
                        index: true,
                        element: <ProjectExportListScreen />,
                    },
                    {
                        path: "create",
                        handle: { breadcrumb: "projectExport:ProjectExportCreateScreen.title" },
                        element: <ProjectExportCreateScreen />,
                    },
                ],
            },
            {
                path: "users",
                handle: { breadcrumb: "project:projectMenu.users" },
                children: [
                    { index: true, element: <ProjectUserListScreen /> },
                    {
                        handle: { breadcrumb: "user:userCreateScreen.title" },
                        path: "new",
                        element: <ProjectUserCreateScreen />,
                    },
                ],
            },
            {
                path: "protocols",
                handle: { breadcrumb: "protocol:protocolListScreen.projectTitle" },
                element: <Outlet />,
                children: [
                    {
                        index: true,
                        element: <ProtocolListRoute />,
                    },
                    {
                        path: "new",
                        handle: { breadcrumb: "protocol:protocolCreateScreen.projectScopeTitle" },
                        element: <ProtocolCreateRoute />,
                    },
                    {
                        path: ":protocolId",
                        handle: { breadcrumb: "protocol:protocolEditScreen.projectScopeTitle" },
                        element: <ProtocolEditRoute />,
                    },
                ],
            },
            {
                path: "deliverables",
                element: <ProjectDeliverablesScreen />,
            },
        ],
    },
];
